import { useState } from "react";
import { X, DoorOpen } from "lucide-react";
import api from "../../services/api";

var HOURS_LABELS = [];
for (var h = 8; h <= 17; h++) {
  HOURS_LABELS.push({ value: h, label: h.toString().padStart(2, "0") + ":00 - " + (h + 1).toString().padStart(2, "0") + ":00" });
}

export default function RoomBookingModal({ onClose, onSave, selectedDate, slots }) {
  var nameState = useState("");
  var hourState = useState("");
  var durationState = useState("1");
  var notesState = useState("");
  var loadingState = useState(false);
  var errorState = useState(null);

  var dateStr = selectedDate ? selectedDate.toISOString().split("T")[0] : "";

  async function handleSubmit(e) {
    e.preventDefault();
    if (!nameState[0].trim() || !hourState[0]) return;
    loadingState[1](true);
    errorState[1](null);
    try {
      await api.post("/room/bookings", {
        date: dateStr,
        start_hour: parseInt(hourState[0]),
        duration_hours: parseInt(durationState[0]),
        client_name: nameState[0].trim(),
        notes: notesState[0].trim() || null,
      });
      onSave();
    } catch (err) {
      var d = err.response ? err.response.data : null;
      var detail = d ? d.detail : "Erro ao reservar sala";
      errorState[1](typeof detail === "string" ? detail : "Erro ao reservar sala");
    } finally {
      loadingState[1](false);
    }
  }

  var availableSlots = (slots || []).filter(function (s) { return s.available; });

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed bottom-0 left-0 right-0 sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 z-50 sm:max-w-md sm:w-full" data-testid="room-booking-modal">
        <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <div className="p-2 bg-amber-100 rounded-lg"><DoorOpen className="w-5 h-5 text-amber-700" /></div>
              <h2 className="text-lg font-bold text-[#0A2F3D]">Reservar Sala</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          <div className="px-5 pt-3 pb-1">
            <p className="text-sm text-gray-500">Data: <strong>{dateStr}</strong></p>
          </div>
          {errorState[0] && <div className="mx-5 mt-2 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Nome do Cliente *</label>
              <input type="text" value={nameState[0]} onChange={function (e) { nameState[1](e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500"
                placeholder="Nome do cliente" required data-testid="room-form-name" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Horário *</label>
                <select value={hourState[0]} onChange={function (e) { hourState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-amber-500/30"
                  required data-testid="room-form-hour">
                  <option value="">Selecione</option>
                  {availableSlots.map(function (s) {
                    return <option key={s.hour} value={s.hour}>{s.label}</option>;
                  })}
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Duração</label>
                <select value={durationState[0]} onChange={function (e) { durationState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-amber-500/30"
                  data-testid="room-form-duration">
                  <option value="1">1 hora</option>
                  <option value="2">2 horas</option>
                  <option value="3">3 horas</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Observação</label>
              <textarea value={notesState[0]} onChange={function (e) { notesState[1](e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-amber-500/30"
                rows="2" data-testid="room-form-notes" />
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0] || availableSlots.length === 0}
                className="flex-1 px-4 py-2.5 bg-amber-500 text-white rounded-xl text-sm font-medium hover:bg-amber-600 disabled:opacity-50" data-testid="room-form-submit">
                {loadingState[0] ? "Reservando..." : "Reservar Sala"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
